
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { removeItemTime } from '@/utils/arrays'
import { strToDateArray, timeJoin } from '@/utils/dateTime'
@Component({
  name: 'editWallet',
})
export default class extends Vue {
  @Prop({ required: true }) product!: any
  private loading = false
  private form: any = {}
  private openTimes: any[] = [['00', '00', '23', '59']]

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    console.log(this.openTimes, 'hhh')
    this.$emit('close')
  }

  private addItem(array: any[]) {
    const item: any = ['00', '00', '23', '59']
    this.openTimes.push(item)
  }
  private removeItem = removeItemTime

  private list: any = []
  private async editWalletClick() {
    let falg = this.openTimes.every((n) => {
      return n[0] - 0 < 24 && n[2] - 0 < 24 && n[1] - 0 < 60 && n[3] - 0 < 60
    })
    if (falg) {
      this.openTimes.forEach((time: any) => {
        if (time[0]) {
          let str: any = time[0] + ':' + time[1] + '-' + time[2] + ':' + time[3]
          this.list.push(str)
        }
      })
      this.$emit('saveTime', this.list)
    } else {
      this.$message.error('The time entered is incorrect!')
    }
  }

  private blurInput(val, way, index) {
    if (val - 0 < 10) {
      let newValue = val - 0
      val = '0' + newValue
      this.$set(this.openTimes[index], way, val)
    }
  }
  created() {
    if (this.product.length) {
      this.openTimes = []
      this.product.forEach((time: any) => {
        let arr = time.split(':')
        let newArr = arr[1].split('-')
        arr[1] = newArr[0]
        arr.splice(2, 0, newArr[1])
        this.openTimes.push(arr)
      })
    }
  }
}
